// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__120sX","error":"Textarea_error__3HXho","readonly":"Textarea_readonly__2fr_U","disabled":"Textarea_disabled__3ISXG"};